module.exports = __webpack_public_path__ + "static/media/mommyme1.0bd84bad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mommyme1.jpg
// module id = 592
// module chunks = 0